import type { VerificationAdditionalCheckStatusEnum, VerificationStateEnum } from '@/enums';
import type { ICertifications } from '@/lib/interface';
import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import type { GenderEnum } from '@/lib/enum';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TParams = {
	additionalCheckStatus?: VerificationAdditionalCheckStatusEnum;
	additionalCheckState?: VerificationStateEnum;
	gender?: GenderEnum;
};
type TResponseData = ICertifications[];
const EMPTY_CERTIFICATIONS: ICertifications[] = [];

export const useRequestGetCertifications = (params?: TParams, run = true) => {
	const {
		isLoading,
		isFetching,
		data,
		error,
		refetch: refetchCertifications,
		dataUpdatedAt: certificationsUpdatedAt
	} = useQuery({
		queryKey: [routes.api.certifications.base, params, run],
		queryFn: ({ queryKey: [_url, _params, _run] }) =>
			!_run
				? Promise.resolve(null)
				: apiClient
						.get<TResponseData>(_url as string, _params as TParams)
						.then(handleApiResponse)
						.then(data => data?.map(l => ({ ...l, createdAt: dayjs(l.createdAt).toDate() })) ?? [])
	});

	const certifications = data ?? EMPTY_CERTIFICATIONS;

	return {
		isLoadingCertifications: isLoading,
		isRefetchingCertifications: isFetching && !isLoading,
		certificationsUpdatedAt,
		refetchCertifications,
		certifications,
		error
	};
};
